/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { ItemList } from '../_common/constant/item-list';
import { Code } from 'src/refresh/service/constant';
import { HttpClient } from '@angular/common/http';
import { SubmitApplication } from '../_common/submit/SubmitApplication';
import { Path } from '../_common/constant/page-const';
var show = console.log.bind( console );

@Component({ 
      selector: 'provincial_payment',
      templateUrl: './provincial_payment.component.html',
      styleUrls: ['./provincial_payment.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class ProvincialPaymentComponent extends FormBaseComponent implements OnInit {

       private submitApplication:SubmitApplication;
       public  disabled:boolean = true;

       constructor( protected router: Router ,
                    public timerService:TimerService,
                              httpClient:HttpClient,
                              items:ItemList,
                    public    data:InputData ) {

                    super(router,timerService);  

                    super.setNextPage(null,Path.OrderSummary);

                    this.submitApplication = new SubmitApplication(httpClient,data,timerService,items);

                    this.disabled = !!data.subject.siteKey;

                    InputData.currentPageIdx = 25;
       }

       public ngOnInit() {
       	      
       }

       
       public onNextClick() : boolean  {
              if ( !this.disabled )
                    this.submitApplication.submit();

              return true;      
       }

       public resolved(captchaResponse: string) {
              
              this.data.subject.captcha = captchaResponse;
              this.disabled = false;
       }
}
